export default __webpack_public_path__ + "static/media/eli_yered.4e2b53dc.jpeg";